import {
  SkuSlaBuyerQtyRangeOptionEnum,
  SkuSlaBuyerRangeDTO,
  SkuSlaSupplierRangeDTO,
} from '../../../../../domains/slaDomain';
import { FormInstance } from 'antd';

export enum rangeTypeEnum {
  high = 'high',
  low = 'low',
}

export type AutoSplitQuantity = {
  index: number;
  level: rangeTypeEnum;
  value: number;
};

export type Ranges = {
  quantityRanges: any;
  [key: string]: any;
};

export const initRange = (
  high: number,
  low: number,
  isSupplier: boolean
): SkuSlaSupplierRangeDTO | SkuSlaBuyerRangeDTO => {
  if (isSupplier) {
    return {
      high,
      low,
      priceToPaySupplier: 0,
      pricingEnginePrice: 0,
    };
  }
  return {
    markup: 0,
    priceEach: 0,
    priceEachFromSupplierPrice: 0,
    markupValue: 0,
    low,
    high,
    option: SkuSlaBuyerQtyRangeOptionEnum.NO_ADDITIONAL,
    turnaroundHours: 0,
  };
};

export const autoSplitQuantity = async (
  { index, level, value }: AutoSplitQuantity,
  form: FormInstance,
  isSupplier: boolean
) => {
  const x = ({ index, level, value }: AutoSplitQuantity, d?: Ranges): any => {
    const formData = form.getFieldsValue();
    const allData = d || formData;
    const { ranges, maxQty } = allData;
    const maxQ = maxQty;
    const qLen = ranges.length - 1,
      curQ = ranges[index],
      preQ = ranges[index - 1],
      nextQ = ranges[index + 1];
    const isLastLine = qLen === index;
    const insertIndex = index + 1;
    const { low, high } = rangeTypeEnum;
    const isHighLevel = level === high;
    const isLowLevel = level === low;
    if (isHighLevel) {
      curQ.high = value;
    } else if (isLowLevel) {
      curQ.low = value;
    }
    if (isLowLevel) {
      if (index === 0) {
        ranges[0].low = 1;
      } else {
        if (curQ.low >= curQ.high) {
          curQ.low = curQ.high - 1;
          x({ index: index - 1, level: high, value: curQ.low - 1 }, allData);
        } else {
          if (curQ.low <= 1) {
            ranges.splice(0, index);
          } else if (curQ.low > preQ.high) {
            ranges.splice(
              index,
              0,
              initRange(curQ.low - 1, preQ.high + 1, isSupplier)
            );
          } else {
            let highQIndex = 0,
              oldQIndex = index;
            while (oldQIndex > 0) {
              --oldQIndex;
              if (
                curQ.low > ranges[oldQIndex].high ||
                curQ.high === nextQ.high
              ) {
                highQIndex = oldQIndex;
                oldQIndex = 0;
              }
            }
            ranges.splice(highQIndex + 1, index - highQIndex - 1);
            ranges[highQIndex].high = curQ.low - 1;
          }
        }
      }
    } else if (isHighLevel) {
      const setNextRange = () =>
        x({ index: index + 1, level: low, value: curQ.high + 1 }, allData);
      if (isLastLine) {
        if (curQ.high >= maxQ) {
          curQ.high = maxQ;
        } else {
          if (curQ.high <= curQ.low) {
            curQ.high = maxQ;
          } else {
            ranges.push(initRange(maxQ, curQ.high + 1, isSupplier));
          }
        }
      } else {
        if (curQ.high >= maxQ) {
          ranges.splice(insertIndex);
          ranges[ranges.length - 1].high = maxQ;
        } else {
          if (curQ.high <= curQ.low) {
            curQ.high = curQ.low + 1;
            setNextRange();
          } else {
            if (curQ.high >= nextQ.low) {
              let lowQIndex = index,
                oldQIndex = index;
              while (oldQIndex < qLen) {
                oldQIndex++;
                if (curQ.high > ranges[oldQIndex].low) {
                  lowQIndex = oldQIndex;
                }
              }
              ranges.splice(index + 1, lowQIndex - index - 1);
              ranges[index + 1] = {
                ...ranges[index + 1],
                low: curQ.high + 1,
              };
            } else {
              ranges.splice(
                insertIndex,
                0,
                initRange(nextQ.low - 1, curQ.high + 1, isSupplier)
              );
            }
          }
        }
      }
    }
    return allData;
  };
  const newAllData = x({ index, level, value });
  form.setFieldsValue(newAllData);
};
